import { v4 as uuidv4 } from 'uuid';

import type { DialplanDetailedDataBase, NodeDetailed } from './types';
import type { CallflowCustomRouter, CallflowDisconnect } from '@ragu-components/ord-types';

export const defaultEntryNode = (resource = 'callflows'): CallflowCustomRouter | CallflowDisconnect => {
  const metadata = {
    ingord: {
      position: { x: 110, y: 0 },
    },
  };
  if (resource.endsWith('mobility_configurations')) {
    return {
      node_id: uuidv4(),
      reason: 'normal',
      type: 'disconnect',
      metadata,
    };
  }
  return {
    type: 'custom_router',
    node_id: uuidv4(),
    match_property: 'caller_id_number',
    match_rules: [],
    metadata,
  };
};

// Used for testing
export const stressTestData = (nodeCount = 500): DialplanDetailedDataBase => {
  const entry = defaultEntryNode();
  const nodes: NodeDetailed[] = [];
  for (let i = 0; i < nodeCount; i++) {
    if (i % 10 === 0) {
      nodes.push({
        type: 'router',
        node_id: `${i}`,
        match_property: 'caller_id_number',
        match_rules: [
          {
            match_rule: '12345679',
            connection: { next_id: `${i + 1}` },
          },
          {
            match_rule: '987654321',
            connection: { next_id: `${i + 2}` },
          },
          {
            match_rule: '2233445566',
            connection: { next_id: `${i + 3}` },
          },
          {
            match_rule: '1|2',
            connection: { next_id: `${i + 4}` },
          },
          {
            match_rule: '(3|4)56789',
            connection: { next_id: `${i + 5}` },
          },
          {
            match_rule: '12345679',
            connection: { next_id: `${i + 6}` },
          },
          {
            match_rule: '987654321',
            connection: { next_id: `${i + 7}` },
          },
          {
            match_rule: '2233445566',
            connection: { next_id: `${i + 8}` },
          },
          {
            match_rule: '1|2',
            connection: { next_id: `${i + 9}` },
          },
          {
            match_rule: '(3|4)56789',
            connection: { next_id: `${i + 10}` },
          },
        ],
        metadata: {},
      });
    } else {
      nodes.push({
        node_id: `${i}`,
        metadata: {},
        type: 'answer',
        delay: 0,
        connection: { next_id: `${i + 1}` },
      });
    }
  }
  return {
    entry,
    nodes,
  };
};
